// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1cOTw","label":"CategoryService_label__2wy-y","location":"CategoryService_location__3t19L"};